module.exports = __webpack_public_path__ + "static/media/cassette-tape.bff91dee.svg";